import { OrdersDto } from '../../types';
import OrderApi from '@/features/OrderHistory/services';

const orderApi = new OrderApi();
export const getOrders = async (take: number, skip: number, language: string): Promise<OrdersDto | undefined> => {
    return await orderApi.getOrders(take, skip, language);
};
